/**
 * Contacts directory (full Contacts page) — filter the contact cards by the
 * selected city tab and hide any sector section left without visible cards.
 *
 * Shares the tab/card classes with the Contacts grid block but keys off its
 * own `.contacts-directory` root so the two never double-bind.
 */
export function initContactsDirectory() {
    document.querySelectorAll('.contacts-directory').forEach((root) => {
        const tabs = Array.from(root.querySelectorAll('.contacts-grid__tab'));
        const cards = Array.from(root.querySelectorAll('.contacts-grid__card'));
        const sectors = Array.from(root.querySelectorAll('.contacts-grid__sector'));

        if (!tabs.length || !cards.length) {
            return;
        }

        const select = (city) => {
            tabs.forEach((tab) => {
                const active = tab.dataset.city === city;
                tab.classList.toggle('bg-blue', active);
                tab.classList.toggle('text-white', active);
                tab.classList.toggle('text-black', !active);
                tab.setAttribute('aria-pressed', active ? 'true' : 'false');
            });

            cards.forEach((card) => {
                const cities = (card.dataset.cities || '').split(' ').filter(Boolean);
                card.hidden = !cities.includes(city);
            });

            // Drop sector headings that have no contacts in the selected city.
            sectors.forEach((sector) => {
                const visible = sector.querySelectorAll('.contacts-grid__card:not([hidden])').length;
                sector.hidden = visible === 0;
            });
        };

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => select(tab.dataset.city));
        });

        // Activate the first city on load to match the design.
        select(tabs[0].dataset.city);
    });
}
